export let GLOBAL = {
  //Produccion
  //url: 'https://asistentedesalud.nayarit.gob.mx/IPLANAY_INMUEBLES/restful/index.php/'
  url: 'https://inmuebles.iplanay.gob.mx/restful/index.php/'
};
